
<div class="flow-empty-state-wrapper" :position="position">
	<Container
		direction="column"
		padding="0px 12px"
		align="center"
		align-self="center"
		:gap="24"
		:shrink="0"
		class="max-width-400"
	>
		<Pictogram v-if="icon && shape !== 'none'" :shape="shape" size="large">
			<Icon
				:name="computedIcon.name"
				:type="computedIcon.type"
				:size="computedIcon.size"
				:state="computedIcon.state"
				:effects="false"
				:color="computedIcon.color"
			/>
		</Pictogram>
		<Icon
			v-if="icon && shape === 'none'"
			:name="computedIcon.name"
			:type="computedIcon.type"
			:size="computedIcon.size"
			:state="computedIcon.state"
			:effects="false"
			:color="computedIcon.color"
		/>

		<Typography
			v-if="message"
			type="h2"
			weight="bold"
			color="dark"
			align="center"
			data-qa-empty-state-message
			>{{ message }}</Typography
		>
		<Typography v-if="subtitle" type="p1-para" align="center" data-qa-empty-state-subtitle>{{
			subtitle
		}}</Typography>
		<Button
			v-if="action"
			state="outlined"
			:full-width="false"
			data-qa-empty-state-action
			@click="$emit('actions')"
			>{{ action }}</Button
		>
	</Container>

	<slot />
</div>
